import { TCountry } from './CountrySelect'

/**
 * Converts a country name to its ISO 3166-1 alpha-2 code
 * Used for compatibility with forms that store country names instead of codes
 */
export const getCountryCodeByName = (
  countryName: string,
  countries: TCountry[]
): string => {
  const country = countries.find(
    c => c.name.toLowerCase() === countryName.toLowerCase()
  )
  return country?.code || ''
}

/**
 * Converts an ISO 3166-1 alpha-2 code to its country name
 * Used for compatibility with forms that need country names
 */
export const getCountryNameByCode = (
  code: string,
  countries: TCountry[]
): string => {
  const country = countries.find(c => c.code === code)
  return country?.name || ''
}
